export const O_QUE_ACONTECE_TITLE = "O que acontece";
export const ATIVAR_LABEL = "Ativar";
export const INATIVAR_LABEL = "Inativar";
